export default {
  '': 'Home',
  'bio': 'Bio',
	'resume': 'Resume',
  // 'profile': {
  //   '': 'Home',
  //   'bio': 'Bio',
  // 	'resume': 'Resume',
  // }
}



// WEBPACK FOOTER //
// ./src/routes.js